import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("CRM render error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="max-w-xl mx-auto my-10 bg-[#0F2E23] border border-red-400/30 rounded-xl p-8 text-center">
        <AlertTriangle className="w-8 h-8 text-red-300 mx-auto" />
        <h2 className="mt-3 text-lg font-serif text-white">This section hit a problem</h2>
        <p className="mt-2 text-sm text-emerald-100/60">The rest of the CRM is still working. Any note you were typing has been kept as a draft.</p>
        <p className="mt-2 text-[11px] font-mono text-red-200/60 break-words">{String(this.state.error?.message || this.state.error)}</p>
        <div className="mt-5 flex justify-center gap-2">
          <button data-testid="error-boundary-retry" onClick={() => this.setState({ error: null })} className="flex items-center gap-1.5 text-sm bg-brass text-emerald-950 font-semibold rounded-lg px-4 py-2"><RotateCcw className="w-4 h-4" /> Try again</button>
          <button data-testid="error-boundary-home" onClick={() => { window.location.href = "/crm"; }} className="text-sm bg-white/5 hover:bg-white/10 text-white rounded-lg px-4 py-2">Go to dashboard</button>
        </div>
      </div>
    );
  }
}
